import { v1ApiClient } from '@/services';
import type { PathParams, ResponseBody } from '@/shared/api/generated';

import type { YotpoInfo } from '../model';

type YotpoListPath = '/v1/workspaces/{workspace_id}/yotpo';

/**
 * Yotpo 연동 정보 목록 조회
 * 백엔드 전환기 방어: 단일 객체면 배열로 래핑
 */
export const getYotpoInfo = async ({
  workspace_id,
}: PathParams<YotpoListPath, 'get'>): Promise<YotpoInfo[]> => {
  const res = await v1ApiClient.get<ResponseBody<YotpoListPath, 'get'>>(
    `/workspaces/${workspace_id}/yotpo`,
  );
  const data = res.data;
  const items = Array.isArray(data) ? data : data ? [data] : [];
  // ProviderContainer 호환: state → import_state 매핑
  return items.map((item) => ({ ...item, import_state: item.state }));
};
